// extracted by mini-css-extract-plugin
export default {"bill":"AddExpenditure_bill__tJ5Qx","campos":"AddExpenditure_campos__sNAwc","botao":"AddExpenditure_botao__Q+4ZO"};